import React from 'react';
import ModalCommon from '../../../components/Input/ModalCommon';
import { Spin } from 'antd';
import { useState } from 'react';
import Button from '../../../components/Button';
import CeuServices from 'services/CeuServices';
import { toast } from 'sonner';
import { NO_INTERNET } from 'components/messageError';

const ModalConfirmDeleteCEU = ({ onCancel, onSuccess, isOpen, id }) => {
  const [loading, setLoading] = useState(false);

  const deleteCEU = (id) => {
    setLoading(true);
    CeuServices.deleteCeus(id)
      .then((res) => {
        if (res.isOk) {
          onSuccess();
          onCancel();
        }
      })
      .catch(() => toast.error(NO_INTERNET))
      .finally(() => setLoading(false));
  };

  return (
    <Spin spinning={loading}>
      <ModalCommon
        open={isOpen}
        width={600}
        onCancel={onCancel}
        footer={
          <div className="flex h-max justify-end gap-5 border-t border-[#e9e9e9] pt-[15px]">
            <Button btnType="back" width={120} height={40} onClick={onCancel}>
              キャンセル
            </Button>
            <Button
              type="primary"
              width={120}
              height={40}
              loading={loading}
              onClick={() => deleteCEU(id)}
              fontSize={14}
            >
              削除する
            </Button>
          </div>
        }
        title="削除"
      >
        <div
          style={{
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 20,
            fontWeight: '400',
            color: '#000000',
          }}
          className="h-[130px] text-[15px]"
        >
          選択したCEU履歴を削除しますか？
          <br />
          この操作は戻せません。
        </div>
      </ModalCommon>
    </Spin>
  );
};

export default ModalConfirmDeleteCEU;
